<template>
    <div class="company-list">
        
        <!-- city -->
        <div class="form-group row">
            <label for="city" class="col-sm-3 col-form-label">{{ 'company-list.city' | translate }}</label>
            <div class="col-sm-9">
                <select class="form-control" style="width: auto;" :class="{'is-invalid': errors.city}" id="city" v-model="city" @change="onCityChange" required autocomplete="false">
                    <option value=""></option>
                    <option v-for="_city in cities" :key="_city" :value="_city">{{ _city }}</option>
                </select>

                <div v-if="errors.city" class="invalid-feedback">
                    {{ errors.city[0] }}
                </div> 
            </div>
        </div>
        
        <!-- industry -->
        <div v-if="city" class="form-group row">
            <label for="industry" class="col-sm-3 col-form-label">{{ 'company-list.industry' | translate }}</label>
            <div class="col-sm-9">
                <select class="form-control" style="width: auto;" :class="{'is-invalid': errors.industry}" id="industry" v-model="industry" @change="onIndustryChange" required autocomplete="false">
                    <option value=""></option>
                    <option v-for="_industry in industries" :key="_industry.key" :value="_industry.key">{{ _industry.label }}</option>
                </select>

                <div v-if="errors.industry" class="invalid-feedback">
                    {{ errors.industry[0] }}
                </div> 
            </div>
        </div>

        <div v-if="!selectedCompany && companies && companies.length > 0" class="companies">
            <div class="row">
            
                <div v-for="company in companies" :key="company.uuid" class="col-md-4 mb-4">
                    <div class="card h-100">
                        <div class="card-body">
                            <img v-if="company.picture" class="img-fluid mb-3" :src="company.picture" :alt="company.name" :title="company.name">
                            <h5 class="card-title">{{ company.name }}</h5>
                        </div>
                        <div class="card-footer bg-white border-0 pr-3 pb-3">
                            <div v-if="company.nextTimeslot" class="card-text">
                                <span class="text-primary border-bottom border-primary">{{ 'company-list.availability' | translate }}</span>
                                <span class="d-flex">
                                    <span class="align-self-center">{{ company.nextTimeslot['datetime'] }}</span>
                                    <!-- <i class="fas fa-circle float-right text-{{ $company->nextTimeslot['color'] }} h2 font-weight-bold mb-0 ml-2" style="line-height: 26px;"></i> -->
                                    <i class="fas fa-circle traffic-light ml-auto" :class="['text-' + company.nextTimeslot['color']]"></i>
                                </span>
                            </div>
                        </div>
                        <div class="card-footer">
                            <!-- <a v-if="company.reservationUrl" :href="company.reservationUrl" class="btn btn-primary">{{ 'company-list.reserve' | translate }}</a> -->
                            <button type="button" class="btn btn-primary" @click="selectCompany(company)">{{ 'company-list.reserve' | translate }}</button>
                            <!-- <br />
                            <span class="text-muted">{{ company.industry_label }}</span> -->
                        </div>
                    </div>
                </div>

            </div>
        </div>
            
        <div v-if="selectedCompany" class="reservation-calendar-wrapper">

            <button class="btn btn-danger" @click="cancelReservation">{{ 'company-list.cancel-reservation' | translate }}</button>

            <!-- :user="{{ auth()->user() ? auth()->user()->toJson() : 'null' }}" -->
            <!-- :countries="{{ countryHelper()->getActive()->toJson() }}" -->
            <reservation-calendar
                :company="selectedCompany"
            ></reservation-calendar>
        </div>

    </div>
</template>

<script>
export default {
    name: 'company-list',
    props: [
        'cities',
        'industries',
    ],
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            errors: {},

            city: '',
            industry: '',

            companies: [],

            selectedCompany: null,
        }
    },
    mounted() {
        if(localStorage.prefered_city) {
            this.city = localStorage.prefered_city;
        }

        if(localStorage.prefered_industry) {
            this.industry = localStorage.prefered_industry;
        }

        this.loadCompanies();
    },
    methods: {

        onCityChange() {
            localStorage.prefered_city = this.city;
            this.selectedCompany = null;
            this.loadCompanies();
        },

        onIndustryChange() {
            localStorage.prefered_industry = this.industry;
            this.selectedCompany = null;
            this.loadCompanies();
        },

        loadCompanies() {
            if(!this.city || !this.industry) return;

            this.showLoader();

            this.companies = [];

            axios.post(this.routes.company_list_component.get, {
                city: this.city,
                industry: this.industry,
            })
            .then(response => {
                this.hideLoader();
                
                this.companies = response.data.companies;

            }).catch(error => {
                this.hideLoader();
                
                console.error(error);
                Swal.fire({
                    icon: 'error',
                    title: this.translate('error'),
                });
            });
        },

        selectCompany(company)
        {
            this.selectedCompany = company;
        },

        cancelReservation()
        {
            this.selectedCompany = null;
            this.loadCompanies();
        },

    }
}
</script>